/* pantallas-alumno (B): EL RECUADRO DE ESTADO DE PAGINA (I2 del Panel; "Estados de pagina" de la
   parte 2 y P1 de la parte 1).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Fondo #141414, borde #222222, radio 18, relleno 40 20: icono de 26 en un cuadro de 56 #1A1A1A, el
   texto de hoy en 14 px #9A9A9A (con titulo, el titulo va en 16 seminegrita #E6E6E5) y, si hoy lo
   tiene, el boton naranja ("Retry", "Go to Study Center", "Go to Dashboard", "Start Studying").
   - `tipo="no_cargo"` y `tipo="sin_conexion"`: nube tachada.
   - `tipo="vacio"`: el icono de la pantalla (`icono`).
   - La app sin red y sin nada guardado: el mismo recuadro con su texto largo y SIN `accion`.
   Los textos los pone quien lo usa (los de hoy, con su llave de hoy).

   Por que no envuelve `components/panel/RecuadroNoCargaron.js`: ese trae FIJOS los textos del Panel
   ("We couldn't load your documents") y su boton, y su cuadro mide 48. Esta pieza es la misma caja
   con los textos y el icono por prop y las medidas de la parte 2. */
import React from 'react';
import { CloudOff, Inbox } from 'lucide-react';
import Boton from './botones';

export default function RecuadroDeEstado({ tipo = 'no_cargo', icono, titulo, texto, accion, testid, className = '' }) {
  const Icono = icono || (tipo === 'vacio' ? Inbox : CloudOff);
  return (
    <div data-testid={testid} data-tipo={tipo}
      className={`rounded-[18px] border border-[#222222] bg-[#141414] px-5 py-10 flex flex-col items-center text-center ${className}`.trim()}>
      <div data-parte="icono" aria-hidden="true" className="w-14 h-14 rounded-2xl bg-[#1A1A1A] flex items-center justify-center mb-3">
        <Icono className="w-[26px] h-[26px] text-[#9A9A9A]" />
      </div>
      {titulo ? <p data-parte="titulo" className="text-[16px] leading-snug font-semibold text-[#E6E6E5] break-words">{titulo}</p> : null}
      {texto ? <p data-parte="texto" className={`${titulo ? 'mt-1 ' : ''}max-w-[440px] text-[14px] leading-5 text-[#9A9A9A] break-words`}>{texto}</p> : null}
      {accion ? (
        <Boton className="mt-4" icono={accion.icono} trabajando={!!accion.trabajando} disabled={!!accion.disabled}
          onClick={accion.onClick} testid={testid ? `${testid}-accion` : accion.testid}>
          {accion.texto}
        </Boton>
      ) : null}
    </div>
  );
}
